module.exports = __webpack_public_path__ + "assets/img/danelle_oberholtzer.9eeec59d.png";